import type { PhaseLockRules } from '../core/phase-lock-rules';
import { PhaseName } from './phases';

export const phaseLockRules: PhaseLockRules = {
    [PhaseName.RelationTypes]: {
        message:
            'Once you proceed, all previous steps will be locked and available for viewing only. They cannot be edited. Are you sure you want to proceed?',
        locking: [
            PhaseName.RiskScoping,
            PhaseName.ScopingAssets,
            PhaseName.RelationTypes,
        ],
    },
    [PhaseName.ThreatPathAndVectors]: {
        message:
            'Once you proceed, all previous steps will be locked and available for viewing only. They cannot be edited. Are you sure you want to proceed?',
        locking: [PhaseName.ThreatModeling, PhaseName.ThreatPathAndVectors],
    },
};
